import { get } from "react-hook-form";

import { FormErrorProps } from "uiKit/inputs/fieldError/index";

export function shouldShowFormError({ errors, name }: FormErrorProps): boolean {
    return !!get(errors, name, "");
}
